import CompaniesService from '../../services/CompaniesService';
import toast from 'react-hot-toast';

// Action Types
export const LOADING_TOGGLE_ACTION = '[Companies] Loading Toggle';
export const GET_COMPANIES_SUCCESS = '[Companies] Get Companies Success';
export const GET_COMPANIES_FAILED = '[Companies] Get Companies Failed';
export const GET_COMPANY_BY_ID_SUCCESS = '[Companies] Get Company By ID Success';
export const GET_COMPANY_BY_ID_FAILED = '[Companies] Get Company By ID Failed';
export const CREATE_COMPANY_SUCCESS = '[Companies] Create Company Success';
export const CREATE_COMPANY_FAILED = '[Companies] Create Company Failed';
export const UPDATE_COMPANY_SUCCESS = '[Companies] Update Company Success';
export const UPDATE_COMPANY_FAILED = '[Companies] Update Company Failed';
export const DELETE_COMPANY_SUCCESS = '[Companies] Delete Company Success';
export const DELETE_COMPANY_FAILED = '[Companies] Delete Company Failed';
export const GET_COMPANIES_FOR_SELECT_SUCCESS = '[Companies] Get Companies For Select Success';
export const CLEAR_CURRENT_COMPANY = '[Companies] Clear Current Company';
export const CLEAR_ERRORS = '[Companies] Clear Errors';
export const RESET_COMPANY_SUCCESS = '[Companies] Reset Success State';
export const GET_COMPANIES_STATISTICS_SUCCESS = '[Companies] Get Companies Statistics Success';
export const GET_COMPANIES_STATISTICS_FAILED = '[Companies] Get Companies Statistics Failed';

// Action Creators
export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}

export function getCompaniesAction(params = {}) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await CompaniesService.getAllCompanies(params);
            if (response.success) {
                dispatch({
                    type: GET_COMPANIES_SUCCESS,
                    payload: {
                        data: response.data,
                        pagination: response.pagination
                    }
                });
            } else {
                dispatch({
                    type: GET_COMPANIES_FAILED,
                    payload: response.message
                });
            }
        } catch (error) {
            dispatch({
                type: GET_COMPANIES_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch companies'
            });
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function getCompanyByIdAction(id) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await CompaniesService.getCompanyById(id);
            dispatch({
                type: GET_COMPANY_BY_ID_SUCCESS,
                payload: response.data
            });
        } catch (error) {
            dispatch({
                type: GET_COMPANY_BY_ID_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch company'
            });
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function createCompanyAction(companyData, navigate) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await CompaniesService.createCompany(companyData);
            if (response && response.success === true) {
                dispatch({
                    type: CREATE_COMPANY_SUCCESS,
                    payload: response.data
                });
                toast.success(response.message || "Company created successfully");
                dispatch(resetCompanySuccess());
                if (navigate) {
                    navigate('/companies');
                }
            } else {
                dispatch({
                    type: CREATE_COMPANY_FAILED,
                    payload: response.message || 'Failed to create company'
                });
                toast.error(response.message || "Failed to create company");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to create company';
            dispatch({
                type: CREATE_COMPANY_FAILED,
                payload: errorMessage
            });
            toast.error(errorMessage);
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function updateCompanyAction(id, companyData, navigate) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await CompaniesService.updateCompany(id, companyData);
            if (response && response.success === true) {
                dispatch({
                    type: UPDATE_COMPANY_SUCCESS,
                    payload: response.data
                });
                toast.success(response.message || "Company updated successfully");
                dispatch(resetCompanySuccess());
                if (navigate) {
                    navigate('/companies');
                }
            } else {
                dispatch({
                    type: UPDATE_COMPANY_FAILED,
                    payload: response.message || 'Failed to update company'
                });
                toast.error(response.message || "Failed to update company");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to update company';
            dispatch({
                type: UPDATE_COMPANY_FAILED,
                payload: errorMessage
            });
            toast.error(errorMessage);
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function deleteCompanyAction(id) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await CompaniesService.deleteCompany(id);
            if (response && response.success === true) {
                dispatch({
                    type: DELETE_COMPANY_SUCCESS,
                    payload: id
                });
                toast.success(response.message || "Company deleted successfully");
                dispatch(resetCompanySuccess());
            } else {
                dispatch({
                    type: DELETE_COMPANY_FAILED,
                    payload: response.message || 'Failed to delete company'
                });
                toast.error(response.message || "Failed to delete company");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to delete company';
            dispatch({
                type: DELETE_COMPANY_FAILED,
                payload: errorMessage
            });
            toast.error(errorMessage);
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function getCompaniesForSelectAction() {
    return async (dispatch) => {
        try {
            const response = await CompaniesService.getCompaniesForSelect();
            dispatch({
                type: GET_COMPANIES_FOR_SELECT_SUCCESS,
                payload: response.data
            });
        } catch (error) {
            console.error('Failed to fetch companies for select:', error);
        }
    };
}

export function clearCurrentCompany() {
    return {
        type: CLEAR_CURRENT_COMPANY
    };
}

export function clearErrors() {
    return {
        type: CLEAR_ERRORS
    };
}

export function resetCompanySuccess() {
    return {
        type: RESET_COMPANY_SUCCESS
    };
}